import { gql } from '@apollo/client';

// Edit-only mode: turn a project/library that failed because its video has no
// speech into one clip from startSeconds to endSeconds (at most a minute). The returned
// fields update the cached entity, so the page leaves its failure screen.
export const START_EDIT_ONLY_LIBRARY = gql`
  mutation StartEditOnlyLibrary($id: ID!, $startSeconds: Float!, $endSeconds: Float) {
    startEditOnlyLibrary(id: $id, startSeconds: $startSeconds, endSeconds: $endSeconds) {
      id
      curation_status
      failure_code
      edit_only
    }
  }
`;

export const START_EDIT_ONLY_PROJECT = gql`
  mutation StartEditOnlyProject($id: ID!, $startSeconds: Float!, $endSeconds: Float) {
    startEditOnlyProject(id: $id, startSeconds: $startSeconds, endSeconds: $endSeconds) {
      id
      curation_status
      failure_code
      edit_only
    }
  }
`;
